import React, { useState } from "react";
import PropTypes from "prop-types";
import SubMenu from "../SubMenu/SubMenu";
import SubMenuCapabilities from "../SubMenu/SubMenuCapabilities";
import { trackMainMenuClick } from "../../lib/analytic/trackMainMenu";

const MainMenuItem = ({
  url,
  image,
  title,
  childrenItems,
  setCurrentMenu,
  setShowMainMenu,
  setButtonBackText,
  isMobile,
  id,
  type,
  viewMode,
  toggleModal,
}) => {
  // Check if menu item have submenu.
  const haveChildren =
    Object.keys(childrenItems).length !== 0 &&
    childrenItems.constructor === Object;
  const [isExpanded, setIsExpanded] = useState(false);
  // Added class if have children.
  const haveChildrenClass = haveChildren ? " link--with-children" : "";
  // Detect if menu is language menu.
  const languageMenu = type === "language";
  // Detect if Capabilities menu.
  const isCapabilitiesMenu = viewMode === 'menu_capabilities' ? true : false;
  // Func for show submenu.
  const showSubmenu = (event) => {
    if (isMobile && haveChildren) {
      setShowMainMenu(false);
      setCurrentMenu({
        ...childrenItems,
        viewMode: viewMode,
      });
      setButtonBackText(title);
      event.preventDefault();
    }
    if (!isMobile && languageMenu) {
      setIsExpanded(!isExpanded);
    }
    trackMainMenuClick(event.currentTarget.innerText, event.currentTarget.href);
    if (isMobile && !haveChildren) {
      if (event.currentTarget.href.indexOf(window.location.href) > -1) {
        toggleModal(event);
      }
    }
    return event.target;
  };
  // Add id for submenu.
  const idSubMenu = `submenu-${id}`;
  // Classes for show submenu.
  const expandedSubMenu = isExpanded ? `submenu--open` : "";
  const activeLinkClass = isExpanded ? `link--main-menu--active` : "";
  // Aria attr for link if have children.
  const ariaAttributesLink = haveChildren && {
    "aria-haspopup": "true",
    "aria-controls": idSubMenu,
    role: "menuitem",
  };
  // Aria attr dynamic changes for link if have children.
  const ariaAttributesLinkDynamic = haveChildren && {
    "aria-expanded": isExpanded,
  };
  // Aria attr for submenu.
  const ariaAttributesMenu = {
    "aria-labelledby": id,
    "aria-expanded": isExpanded,
  };
  const showSubmenuOnFocus = (event) => {
    if (haveChildren && !languageMenu) {
      setIsExpanded(true);
    }
    return event.target;
  };
  const hideSubmenuOnBlur = (event) => {
    if (haveChildren) {
      setIsExpanded(false);
    }
    return event.target;
  };

  const onBlurParent = (event) => {
    if (haveChildren) {
      const isFocusedParent =
        event.relatedTarget &&
        event.currentTarget.contains(event.relatedTarget);
      if (!isFocusedParent) {
        setIsExpanded(false);
      }
    }
    return event.target;
  };
  // Show/hide submenu by key.
  const handleItemClick = (event) => {
    const { keyCode } = event;
    if (haveChildren) {
      switch (keyCode) {
        case 13:
          setIsExpanded(true);
          event.preventDefault();
          break;
        case 32:
          setIsExpanded(true);
          event.preventDefault();
          break;
        case 27:
          setIsExpanded(false);
          event.preventDefault();
          break;
        default:
          return event.target;
      }
    }
    return event.target;
  };
  return (
    <li
      className="mb-16 mb-lg-0"
      onMouseLeave={hideSubmenuOnBlur}
      onBlur={onBlurParent}
      role="presentation"
    >
      <a
        onClick={showSubmenu}
        className={`link color-transform link--main-menu${haveChildrenClass} ${activeLinkClass} pl-lg-16 pr-lg-16`}
        href={url}
        role="menuitem"
        id={id}
        onKeyDown={handleItemClick}
        onMouseEnter={showSubmenuOnFocus}
        {...ariaAttributesLink}
        {...ariaAttributesLinkDynamic}
      >
        {languageMenu && image && (
          <div
            className="link--main-menu__image"
            /* eslint-disable-next-line react/no-danger */
            dangerouslySetInnerHTML={{
              __html: image,
            }}
          />
        )}
        <span>{title}</span>
      </a>
      {haveChildren && !isMobile && (
        <div
          role="menu"
          {...ariaAttributesMenu}
          id={idSubMenu}
          data-view={isCapabilitiesMenu}
          className={`submenu ${expandedSubMenu} submenu-${viewMode}`}
        >
          {isCapabilitiesMenu && 
            <SubMenuCapabilities childrenItems={childrenItems} setCurrentMenu={setCurrentMenu} isMobile={isMobile} isCapabilitiesMenu={isCapabilitiesMenu} isExpanded={isExpanded} />
          }
          {!isCapabilitiesMenu && 
            <SubMenu childrenItems={childrenItems} isMobile={isMobile} isCapabilitiesMenu={isCapabilitiesMenu} />
          }
        </div>
      )}
    </li>
  );
};
MainMenuItem.defaultProps = {
  childrenItems: {},
  type: "default",
  image: "",
};

MainMenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  viewMode: PropTypes.string,
  childrenItems: PropTypes.object,
  setCurrentMenu: PropTypes.func.isRequired,
  setShowMainMenu: PropTypes.func.isRequired,
  setButtonBackText: PropTypes.func.isRequired,
  isMobile: PropTypes.bool.isRequired,
  type: PropTypes.string,
  image: PropTypes.string,
  toggleModal: PropTypes.func,
};

export default MainMenuItem;
